
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBilge as ObiBilgeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bilge.js';
 
 
 

 
 export const ObiBilge = createComponent({
   react: React,
   tagName: 'obi-bilge',
   elementClass: ObiBilgeElement,
   events: {
     
   }
  });
 
 